<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>

<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    &lt;!&ndash;====== OFFCANVAS MENU PART ENDS ======&ndash;&gt;-->

<!--    &lt;!&ndash;====== APPIE HEADER PART START ======&ndash;&gt;-->

<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->



    <section class="appie-testimonial-2-area " id="testimonial">
      <div class="container " v-if="!showloading">

        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare" :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >

            <div class="col-lg-12 mt-2">
              <div class="">
                <Commonprofile/>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div style="text-align: center" class="mt-2">
                    <span v-html="title"></span>
                    <span class="badge rounded-pill bluebackground" v-html="countView.title"
                          style="margin: 0px 6px"></span>

                  </div>
                  <br>
                  <div>

                    <div v-if="list.length > 0" >
                      <div class="row">
                        <div class="col-12 col-md-4 temp_10_space "  v-for="(ListData,index) in list"
                             :key="index">
                          <div class="card">
                            <div class="card-body " style="font-size: 15px">
                              <div v-for="ListTitleData in ListData.title" :key="ListTitleData.id" class="row mb-1">

                                <div class=" col-md-11 col-11">
                          <span v-if="ListTitleData.visible === '1'" class="fontboldwight " v-html="ListTitleData.title"
                                style="background: #e1dedea1;font-size: 14px;width: 100%;border-radius: 10px;text-align: center;"></span>
                                </div>
                                <div class=" col-md-1 col-1">
                                  <span v-if="ListData.active == '1'" style="color: green;float: right;font-size: 11px">🟢</span>
                                  <span v-else style="color: red;float: right;font-size: 11px">🔴</span>
                                </div>
                              </div>


                                <div v-for="(SubListData,index) in ListData.list" :key="index" class="row">
                                  <div class="col-6 col-lg-6 col-md-6 ">
                                    <span v-html="SubListData.title" class="fontweight400" ></span>
                                  </div>
                                  <div class="col-6 col-lg-6 col-md-6">
                                    <span v-html="SubListData.content" ></span>
                                  </div>
                                </div>


<!--                                <table style="width: 100%">-->
                                  <!--                      <div >-->

                                  <!--                      </div>-->
<!--                                </table>-->


                                <div class="row mt-2">
                                  <div class="col-6 col-lg-6 col-md-6">
                                    <span v-html="ListData.card[0].title"></span>
                                  </div>
                                  <div class="col-6 col-lg-6 col-md-6">
                                    <span v-html="ListData.card[1].title"></span>
                                  </div>
                                </div>


                              <div v-for="(ListButtonData,index) in ListData.button" :key="index" style="text-align: center">

                                <!--                                              {{ListButtonData}}-->

                                <div v-if="ListButtonData.visible == '1' " class="bluebackground invoicebtn" >
                                  <a :href="ListData.invoice_pdf" target="_blank">
                                    <!--                          <div    >-->
                                    <span v-html="ListButtonData.title"></span>
                                    <!--                          </div>-->
                                  </a>
                                </div>

                              </div>
                            </div>
                          </div>
                          <br>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="card">
                        <div class="card-body" style="text-align: center">

                          <h5><span style="color: blue">Data Not</span> <span style="color: red;">Found!</span></h5>
                          <span style="color: black;font-weight: 800;">நீங்கள் தேடிய தகவல் தற்போது இல்லை</span>
                          <br>
                          <br>
                          <!--                    <button type="button" @click="navigateToSamePage" class="btn btn-success">Exit</button>-->


                        </div>
                      </div>

                    </div>
                    <span v-if="loading" style="text-align: center"> loading...</span>


                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>


      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="customerCareData.label"></span>


              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>


    <!--====== APPIE TESTIMONIAL 2 PART ENDS ======-->

    <!--====== APPIE SPONSER PART START ======-->

    <!--    <sponser-home-two title="Appie works best with" more_title="your favorite platforms" description="Join over 40,000 businesses worldwide."/>-->

    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->

    <!--    <footer-home-two/>-->


    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import SidebarHomeOne from '../HomePage/SidebarHomeOne.vue'
import LoaderAppie from '../LoaderAppie.vue'
// import HeaderHomeTwo from '../HomePage/Header.vue'
// import HeroHomeTwo from './HeroHomeTwo.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import CryptoJS from 'crypto-js';
import Menubar from "@/components/HomePage/menu.vue";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Commonprofile,
    Menubar,
    LoaderAppie,
    // HeaderHomeTwo,
    // SidebarHomeOne,
  },
  data() {
    return {
      loading:false,
      isFetchingData: false,
      lastId:0,
      showloading:false,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      textSize: '',
      countView: [],
      list: [],
      ListTitleData: [],
      ListButtonData: [],
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },
        // {
        //   // name:'contact',
        //   name: 'Notification',
        //   path: '/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {

    if (this.$route.query.page) {
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      try {
        const PaymentHistoryData = await callAxiosWithConfig(this.modifiedString, {'lastId': 0, 'listSize': 0}, 'post');
        // console.log(PaymentHistoryData);
        // console.log(PaymentHistoryData.title);
        this.showloading=false;
        this.title = PaymentHistoryData.title;
        this.textSize = PaymentHistoryData.textSize;
        this.countView = PaymentHistoryData.countView;
        this.list = PaymentHistoryData.list;

        this.showloading=false;

        if (PaymentHistoryData.list.length > 0) {
          this.lastId = PaymentHistoryData.list[PaymentHistoryData.list.length - 1].id;
        }

        this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

        // console.log(this.SideMenu)
        this.$emit("tempData",  this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);
        // this.template = otpdata.template;
        // console.log(this.template)
        // const inputString = otpdata;
        // this.$emit("tempData", this.title);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
      // alert(this.modifiedString);
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    }
    // this.encryptedParam = this.$route.query.page;
    //
    // this.decryptedValue = this.Decrypt(this.encryptedParam);
    // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    // console.log(this.modifiedString)

    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    async handleScroll() {
      if (this.isFetchingData) {
        // alert(this.isFetchingData)
        return;
      }
      // Check if the user has scrolled to the bottom of the page
      const distanceToBottom = document.documentElement.scrollHeight - (window.innerHeight + window.scrollY);
      if (distanceToBottom < 100) {
        this.isFetchingData = true;
        this.loading=true;
        const loadmoreData = await callAxiosWithConfig(this.modifiedString, {'lastId': this.lastId, 'listSize': 0}, 'post');

          // console.log(loadmoreData)
          if (loadmoreData.list.length > 0){
            this.list = [...this.list, ...loadmoreData.list];
            // Update the lastId with the id of the last element in the new data
            this.lastId = loadmoreData.list[loadmoreData.list.length - 1].id;
            this.isFetchingData = false;
            this.loading=false;

          }
          else{
            this.loading=false;
          }


      }
    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async GetPlan(activity, url) {
      // alert(activity)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;

      if (lastPart === 'Employer_Common_Webview_Activity') {

        window.location.href = this.urlData
      }
    },

    async postJob(activity, url) {

      // alert(activity)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;

      if (lastPart === 'Employer_Dynamic_Home_Activity') {

        await this.$router.push('/view-post')
      } else if (lastPart === 'Employer_Company_Register') {
        // alert('krishna')
        await this.$router.push('/company-register')
      }


    }
  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

.maincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;

  width: 100% !important;
}

@media (min-width: 768px) {
  .maincard {
    width: 90% !important;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }
}

</style>
